export enum AppFeatures {
    AGENTS_DIRECTORY = 'agents-directory',
    REALTIME_METRICS = 'realtime-metrics',
    HISTORIC_METRICS = 'historic-metrics',
    QA = 'qa',
    DPA = 'dpa',
    CUSTOMER_INPUTS = 'customer-inputs',
    LIVE_MONITORING = 'live-monitoring',
    LINE_MANAGEMENT = 'line-management',
    CONNECT = 'connect',
    QUICKSIGHT = 'quicksight',
    AUDIO_SETTINGS = 'audio-settings',
    USER_MANAGEMENT = 'user-management',
    QUEUE_STATS = 'queue-stats',
    UPLOAD_ROTA = 'upload-rota',
    KEYWORD_MANAGEMENT = 'keyword-management',
    REPORT_ISSUE = 'report-issue',
    CALL_RECORDING = 'call-recording',
    CALL_TRANSCRIPTION = 'call-transcription',
    CALL_DETAILS = 'call-details',
    CHAT_DETAILS = 'chat-details',
    CALL_COMPREHENSION = 'call-comprehension',
    CALL_HISTORY = 'call-history',
    CHAT_TRANSCRIPTION = 'chat-transcription',
    CHAT = 'chat',
    INTERNAL_MESSAGING = 'internal-messaging',
    ANNOUNCEMENTS = 'announcements',
    CASE = 'case',
    EXTERNAL_DIRECTORY = 'external-directory',
    CALL_PARKING = 'call-parking',
    CALL_PLUCKING = 'call-plucking',
    AGENT_STATUS = 'agent-status',
    CAMPAIGN_MANAGEMENT = 'campaign-management',
    CUSTOM_MESSAGING = 'custom-messaging',
    CASE_MANAGEMENT = 'case-management',
    TASK_HISTORY = 'task-history',
    TASK_DETAILS = 'task-details',
    QUEUED_TASKS = 'queued-tasks',
    AUTOMATED_RULES = 'automated-rules',
    ALL = '*',
    PERMISSIONS = 'permissions',
    APP_CONFIGURATION = 'app-configuration',
    MS_TEAMS_DIRECTORY = 'ms-teams-directory',
    AUDIT_LOG = 'audit-log',
    WELCOME_MESSAGING = 'welcome-messaging',
    WALLBOARDS = 'wallboards',
    WALLBOARDS_ACCESS_MANAGEMENT = 'wallboards-access-management',
    SUPPORT_WEBHID_CONTROL = 'support-webhid-control',
    CONTACT_LOGS = 'contact-logs',
    QUICK_REPLY_MANAGEMENT = 'quick-reply-management',
    QUEUES = 'manage-queue-settings',
    EMAIL_CC_REPLY = 'email-cc-reply',
    OUTBOUND_EMAIL = 'outbound-email',
    AGENT_ASSISTANCE = 'agent-assistance',
    SOCIAL_CHAT_MESSAGES = 'social-chat-messages',
    COLLECT_ANALYTICS = 'collect-analytics',
    IDLE_TIMEOUT = 'idle-timeout',
    CHAT_CONTACT_SEARCH_OPTIONS = 'chat-contact-search-options',
    SOCIAL_MANAGEMENT = 'social-management',
    CONTACT_HISTORY = 'contact-history',
    CHANNEL_SETTINGS = 'channel-settings',
    DISABLE_FORCE_AGENT_OFFLINE = 'disable-force-agent-offline',
    THREAD_EMAIL_REDESIGNED = 'thread-email-redesigned',
    FORWARD_EMAIL = 'forward-email',
    BLOCK_MULTIPLE_BROWSER_TABS = 'block-multiple-browser-tabs',
    FILTER_QUEUES = 'filter-queues',
    FILTER_QUICK_CONNECTS = 'filter-quick-connects',
    SETTINGS_APP_CONFIG_TASK = 'settings-app-config-task',
    SETTINGS_APP_CONFIG_CHAT = 'settings-app-config-chat',
    CONTACT_FLOW_PHRASES = 'contact-flow-phrases',
    ENFORCE_SA_ONE_TAB = 'enforce-sa-one-tab',
    WHATSAPP = 'whatsapp',
    SMS_MESSAGING = 'sms-messaging',
    OUTBOUND_SMS = 'outbound-sms',
    REALTIME_DATA_QUEUES_REDESIGNED = 'real-time-data-queues-redesigned',
    DISABLE_COOKIE_CHECK = 'disable-cookie-check',
    CRM_COMPANION = 'crm-companion',
    RESTRICT_QUEUE_ACCESS = 'restrict-queue-access'
}

export enum AppSubFeatures {
    QA_EDIT = 'qa-edit',
    QA_CREATE = 'qa-create',
    QA_CALIBRATE = 'qa-calibrate',
    QA_READ = 'qa-read',
    QA_REPORTING = 'qa-reporting',
    QA_SELF_REPORTING = 'qa-self-reporting',
    QA_TEMPLATES = 'qa-templates',
    CALL_RECORDING_DOWNLOAD = 'call-recording-download',
    CALL_DETAILS_EDIT = 'call-details-edit',
    DIRECTORY_VIEW_SENSITIVE = 'external-directory-view-sensitive',
    DIRECTORY_VIEW_BLOCKED = 'external-directory-view-blocked',
    DIRECTORY_VIEW_DEPRIORITISED = 'external-directory-view-deprioritised',
    DIRECTORY_EDIT = 'external-directory-edit',
    ANNOUNCEMENTS_PUBLISH = 'announcements-publish',
    TASK_DETAILS_EDIT = 'task-details-edit',
    MANAGE_PERMISSIONS = 'manage-permissions',
    MOVE_CONTACTS = 'move-contacts',
    END_CONTACTS = 'end-contacts',
    REPLY_CONTACTS = 'reply-contacts',
    EXPORT_CONTACTS = 'export-contacts',
    CALL_HISTORY_SETTING = 'call-history-setting',
    AFTER_CALL_WORK_DURATION_SETTING = 'after-call-work-duration-setting',
    AFTER_CALL_EXTENSION_ALLOW_SETTING = 'after-call-extension-allow-setting',
    ALLOW_BARGE = 'allow-barge',
    CCP_ALLOW_SETTING = 'ccp-allow-setting',
    CHAT_HISTORY_TRANSCRIPT = 'chat-history-transcript',
    AGENT_ASSISTANCE_ACKNOWLEDGE = 'agent-assistance-acknowledgement',
    SOCIAL_MANAGEMENT_TWITTER = 'social-management-twitter',
    SOCIAL_MANAGEMENT_FACEBOOK = 'social-management-facebook',
    SOCIAL_MANAGEMENT_INSTAGRAM = 'social-management-instagram',
    CONTACT_HISTORY_VOICE = 'contact-history-voice',
    CONTACT_HISTORY_WEBCHAT = 'contact-history-webchat',
    CONTACT_HISTORY_TASK = 'contact-history-task',
    CONTACT_HISTORY_SOCIAL = 'contact-history-social',
    CONTACT_HISTORY_SOCIAL_TWITTER_TWEET = 'contact-history-social-twitter-tweet',
    CONTACT_HISTORY_SOCIAL_TWITTER_DM = 'contact-history-social-twitter-dm',
    CONTACT_HISTORY_SOCIAL_FACEBOOK_DM = 'contact-history-social-facebook-dm',
    CONTACT_HISTORY_SOCIAL_FACEBOOK_POST = 'contact-history-social-facebook-post',
    CONTACT_HISTORY_SOCIAL_INSTAGRAM_DM = 'contact-history-social-instagram-dm',
    CONTACT_HISTORY_SOCIAL_INSTAGRAM_COMMENT = 'contact-history-social-instagram-comment',
    CONTACT_HISTORY_MESSAGING_WHATSAPP_DM = 'contact-history-messaging-whatsapp-dm',
    CONTACT_HISTORY_SOCIAL_SMS = 'contact-history-social-sms',
    EMAIL_MANAGEMENT = 'email-management',
    SOCIAL_MANAGEMENT = 'social-management',
    MESSAGING_MANAGEMENT = 'messaging-management',
    WEBFORM_MANAGEMENT = 'webform-management',
    WEBCHAT_MANAGEMENT = 'webchat-management',
    QUEUED_TASKS_UPLOAD_ATTACHMENT = 'queued-tasks-upload-attachment',
    QUEUED_TASKS_UPLOAD_BULK_ATTACHMENT = 'queued-tasks-upload-bulk-attachment',
    REPLY_THEN_END = 'reply-then-end',
    REALTIME_DATA_QUEUES_REDESIGNED_v1_6 = 'real-time-data-queues-redesigned-v1.6',
}

export interface IFeature<T extends AppFeatures = AppFeatures> {
    ID: T;
    config: FeatureConfig<T>;
    subfeatures: AppSubFeatures[]
}

interface IDirectoryConfig {
    customFields?: (
        | { type: 'list'; name: string; label: string; options: string[] }
        | { type: 'text'; name: string; label: string }
    )[];
}

interface IChatConfig {
    chatPanelWidthPercent?: number;
    onCustomerInactive?: IInactivityConfig[];
    onCustomerInitiallyInactive?: IInactivityConfig[]
    autoAnswer?: boolean;
    onAgentInactive?: this['onCustomerInactive'];
    canCopyChatTranscript?: boolean;
    messageReceiptsActive?: boolean;
    attachmentsConfig?: {
        enabled: boolean;
        maxFileSizeMB: number;
        acceptedFileTypes: string[];
        maxNumberOfFilesPerMessage: number;
    }
}

interface IInactivityConfig {
    disconnect: boolean
    seconds: number;
    message: string | Record<string, any>;
}

interface IQueueStatsConfig {
    hideHistoricMetrics?: boolean;
    hideQueuesByRoutingProfile?: string[];
}

interface ICallParkingConfig {
    quickConnectID?: string;
}

interface IInternalMessagingConfig {
    appSyncURL: string;
    appSyncRegion: string;
    apiKey: string;
}

interface ILiveMonitoringConfig {
	navigateToDialler?: boolean;
	allowBarge?: boolean;
}

interface ICustomMessagingLanguages {
    label: string;
    data: string;
}
interface ICustomMessagingConfig {
    messageLanguages?: ICustomMessagingLanguages[];
}

interface ILineManagement {
    showWelcomeMessage: boolean;
}

interface IAwolStatus {
    awolStatusName: string;
}

interface IQueueStats {
    showQueueSummary: boolean;
}

interface IQuickSightConfig {
    url: string;
}

interface IAutomatedRulesConfig {
    fields: {
        name: string;
        path: string;
        type: string;
        values: { value: string; label: string }[];
    }[];
}

interface IQueuedTasksConfig {
    contactLogGroup: string;
}
interface IEmailCCReplyConfig {
    ccReplyChecked: boolean;
    enableCCList: boolean;
}

interface ITaskDetailsConfig {
    messages?: {
        enableReply: boolean;
    };
    autoAnswer?: boolean;
}

interface IQAConfig {
    immediateFailThresh: number;
    failTypeHierarchy: string[];
}

interface IIdleTimeoutConfig {
    idleTimeoutSeconds: number;
}

interface ISocialChatMessagesConfig {
    enableFacebookDM: boolean;
    enableInstagramDM: boolean;
    enableFacebookComment: boolean;
    enableTwitterTweet: boolean;
    enableInstagramComment: boolean;
    enableTwitterDM: boolean;
}

interface IFilterQueuesConfig {
    task: RegExp[]
}
export interface IFilterQuickConnectsConfig {
    task: RegExp[]
    voice: RegExp[]
    chat: RegExp[]
}

interface IForwardEmailConfig {
    maxForwards: number;
}

interface ISMSMessagingConfig {
    messageCountThreshold: number;
}

export interface ICampaignManagementConfig {
    customerStackRegion?: string;
}

export type FeatureConfig<T> =
    T extends AppFeatures.EXTERNAL_DIRECTORY
    ? IDirectoryConfig | undefined
    : T extends AppFeatures.QA
    ? IQAConfig | undefined
    : T extends AppFeatures.CHAT
    ? IChatConfig | undefined
    : T extends AppFeatures.QUEUE_STATS
    ? IQueueStatsConfig | undefined
    : T extends AppFeatures.CALL_PARKING
    ? ICallParkingConfig | undefined
    : T extends AppFeatures.INTERNAL_MESSAGING
    ? IInternalMessagingConfig
    : T extends AppFeatures.LIVE_MONITORING
    ? ILiveMonitoringConfig
    : T extends AppFeatures.LINE_MANAGEMENT
    ? ILineManagement
    : T extends AppFeatures.AGENT_STATUS
    ? IAwolStatus
    : T extends AppFeatures.REALTIME_METRICS
    ? IQueueStats
    : T extends AppFeatures.QUICKSIGHT
    ? IQuickSightConfig
    : T extends AppFeatures.CUSTOM_MESSAGING
    ? ICustomMessagingConfig | undefined
    : T extends AppFeatures.AUTOMATED_RULES
    ? IAutomatedRulesConfig
    : T extends AppFeatures.TASK_DETAILS
    ? ITaskDetailsConfig | undefined
    : T extends AppFeatures.EMAIL_CC_REPLY
    ? IEmailCCReplyConfig | undefined
    : T extends AppFeatures.QUEUED_TASKS
    ? IQueuedTasksConfig
    : T extends AppFeatures.IDLE_TIMEOUT
    ? IIdleTimeoutConfig
    : T extends AppFeatures.SOCIAL_CHAT_MESSAGES
    ? ISocialChatMessagesConfig
    : T extends AppFeatures.FORWARD_EMAIL
    ? IForwardEmailConfig
    : T extends AppFeatures.FILTER_QUEUES
    ? IFilterQueuesConfig
    : T extends AppFeatures.FILTER_QUICK_CONNECTS
    ? IFilterQuickConnectsConfig
    : T extends AppFeatures.CAMPAIGN_MANAGEMENT
    ? ICampaignManagementConfig
    : T extends AppFeatures.SMS_MESSAGING
    ? ISMSMessagingConfig
    : never;
